import { Breadcrumb } from '@/components'
import BusinessPartners from './components/BusinessPartners'
import HeroBanner from './components/HeroBanner'
import TravelVision from './components/TravelVision'
import WhyChooseUs from './components/WhyChooseUs'

const AboutUs = () => (
  <div className="min-w-[1200px]">
    <HeroBanner />
    <Breadcrumb currentKey="aboutUs.breadcrumb.current" />
    <WhyChooseUs />
    <BusinessPartners />
    <TravelVision />
  </div>
)

export default AboutUs
